import ClusterMapPanel from "./clusterMapPanel.container";

export default ClusterMapPanel;
